import { AuthRepository } from "../repositories/AuthRepository";

/**
 * Logout Use Case
 * Handles user logout business logic
 */
export class LogoutUseCase {
  constructor(private authRepository: AuthRepository) {}

  /**
   * Execute logout
   * Clears all authentication data
   */
  async execute(): Promise<void> {
    try {
      await this.authRepository.logout();
    } catch (error) {
      // Log error but don't throw - always logout locally
      console.warn(
        "Logout API call failed, but local logout succeeded:",
        error
      );
    }
  }
}
